export enum RoleEnum {
  // 超级管理员
  SUPERADMIN = 'superAdmin',
  // 管理员
  ADMIN = 'admin',

  // 核心运营
  OPERATOR = 'operator',

  // 查看者
  VIEWER = 'viewer',
}
